// React Imports
import { Fragment } from 'react'
import type { ReactNode } from 'react'

// TVStor© branding (cloned from the TVirt GUI-wide sweep, Luca 2026-07-24):
// every "TVStor" the GUI shows carries a superscript © — brandify splits a
// translated string on the word and interleaves the branded mark. The word and
// its symbol never wrap apart (white-space: nowrap on the pair).
//
// Consistency rule, ratified with the sweep: sinks that can only carry PLAIN
// TEXT — tooltip titles, aria-labels, the document <title> / tab titles,
// input placeholders — keep "TVStor" unbranded, because no markup can reach
// them. Every markup-capable render site of a TVStor-bearing string routes
// through brandify instead.
// L'output è UN solo <span> contenitore (Luca 2026-07-30): dentro un flex
// container (i Button MUI) i nodi sciolti diventano flex item separati e gli
// spazi ai loro confini collassano — un unico item inline conserva il
// whitespace normale ovunque.
export const brandify = (text: string): ReactNode => {
  if (!text.includes('TVStor')) {
    return text
  }

  return (
    <span>
      {text.split('TVStor').map((part, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <span style={{ whiteSpace: 'nowrap' }}>
              TVStor<sup style={{ fontSize: '0.6em' }}>©</sup>
            </span>
          )}
          {part}
        </Fragment>
      ))}
    </span>
  )
}
